import React from 'react';
import './index.css';
import { Label14 } from './index';
import { ApiService } from './../utils/ApiService';
import { API_URL } from './../utils/Constants';

export class UploadAbortCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isRetryLoading: false,
            isAbortLoading: false,
        };
    }

    onAbort = async () => {
        try {
            this.setState({ isAbortLoading: true });
            // const merchantIdGlobal = localStorage.getItem("globalMerchantId");
            const roleData = localStorage.getItem("role");
            let merchantIdGlobal = "";
            if (roleData == "SUPERADMIN") {
                merchantIdGlobal = localStorage.getItem("globalMerchantId");
            }
            if (roleData == "SCHOOLADMIN") {
                merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
            }
            const typeURL = (this.props.isUpdateProcessActive) ? API_URL.ABORT_UPDATE_PROGRESS : API_URL.ABORT_DELETE_PROGRESS;
            const url = typeURL +'?schoolId='+merchantIdGlobal;
            // console.log('-> onAbort url : ', url);
            const resp = await ApiService.postRequest(url);
            this.setState({ isAbortLoading: false });
            // console.log('-> onAbort resp : ', resp);
            // if (resp && resp.status && resp.status.code === 'Y' && resp.body) {
            // }
        } catch (err) {
            // console.log('-> onAbort err : ', err);
        }
    }

    onRetry = async () => {
        try {
            this.setState({ isRetryLoading: true });
            // const merchantIdGlobal = localStorage.getItem("globalMerchantId");
            const roleData = localStorage.getItem("role");
            let merchantIdGlobal = "";
            if (roleData == "SUPERADMIN") {
                merchantIdGlobal = localStorage.getItem("globalMerchantId");
            }
            if (roleData == "SCHOOLADMIN") {
                merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
            }
            const typeURL = (this.props.isUpdateProcessActive) ? API_URL.RETRY_UPDATE_PROGRESS : API_URL.RETRY_DELETE_PROGRESS;
            const url = typeURL +'?schoolId='+merchantIdGlobal;
            // console.log('-> onRetry url : ', url);
            const resp = await ApiService.postRequest(url);
            this.setState({ isRetryLoading: false });
            // console.log('-> onRetry resp : ', resp);
            // if (resp && resp.status && resp.status.code === 'Y' && resp.body) {
            // }
            // console.log('****');
        } catch (err) {
            // console.log('-> onRetry err : ', err);
        }
    }

    renderAbortBtn() {
        return (
            <a onClick={this.onAbort}>
                <label className="label14 downloadStatus">Stop</label>
            </a>
        );
    }

    renderRetryBtn() {
        return (
            <a style={{ marginLeft: 24 }} onClick={this.onRetry}>
                <label className="label14 downloadStatus">Resume</label>
            </a>
        );
    }

    render() {
        return (
            <div className="divRow uploadStatusCard">
                <div className="uploadAbortIcon" />
                <div className="divRow uploadStatusMsg">
                    <div className="divColumn" style={{ width: '70%' }}>
                        <Label14>{this.props.title}</Label14>
                        <div />
                        <label className="label12" style={{ color: '#6d758e' }}>{this.props.desc}</label>
                    </div>
                    <div className="divRow">
                        {this.renderAbortBtn()}
                        {this.renderRetryBtn()}
                    </div>
                </div>
            </div>
        );
    }
}